function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.046.486a.75.75 0 01-.032 1.06L4.084 9.02a.85.85 0 01-1.188-.022l-2.68-2.72a.75.75 0 011.068-1.053l2.234 2.267L10.986.454a.75.75 0 011.06.032z",
  fill: "#05A660"
});

function SvgTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTickIcon;